module.exports = __webpack_public_path__ + "static/media/justin-bennett.1d4c4fe1.jpg";